import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SaveEditing from './saveediting'; 
import SaveUI from './saveui';

export default class Save extends Plugin {
    /**
	 * @inheritDoc
	 */
	static get requires() {
		return [ SaveEditing, SaveUI ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Save';
	}
}